// import React, { useRef, useEffect } from 'react';
// import PropTypes from 'prop-types';

// const HtmlViewer = ({ html, key }) => {
//     const iframeRef = useRef(null);

//     useEffect(() => {
//         if (iframeRef.current && html) {
//             const iframe = iframeRef.current;
//             const doc = iframe.contentDocument || iframe.contentWindow.document;
//             doc.open();
//             doc.write(`
//                 <style>
//                  html, body {
//       color-scheme: light;
//     }
//                 </style>
//                 ${html}
//               `);
//             doc.close();

//             Auto-resize iframe height based on content
//             setTimeout(() => {
//                 const height = doc.body.scrollHeight;
//                 iframe.style.height = `${height}px`;
//             }, 100);
//         }
//     }, [html]);

//     return (
//         <iframe
//             ref={iframeRef}
//             title={`html-content-${key}`}
//             sandbox="allow-same-origin"
//             style={{
//                 width: '100%',
//                 border: 'none',
//                 padding: 0,
//                 margin: 0,
//             }}
//         />
//     );
// };

// HtmlViewer.propTypes = {
//     html: PropTypes.string.isRequired,
//     key: PropTypes.number.isRequired,
// };
// export default HtmlViewer;

// import React, { useRef, useEffect } from 'react';
// import PropTypes from 'prop-types';

// const HtmlViewer = ({ html, id, page }) => {
//     const iframeRef = useRef(null);

//     useEffect(() => {
//         if (iframeRef.current && html) {
//             const iframe = iframeRef.current;
//             const doc = iframe.contentDocument || iframe.contentWindow.document;

//             doc.open();
//             doc.write(`
//       <html>
//         <head>
//           <style>
//             html, body {
//               margin: 0;
//               padding: 0;
//               font-family: 'Noto Sans', sans-serif;
//               color-scheme: light;
//               font-weight: 400;
//               font-size:14px;
//             }
//           </style>
//         </head>
//         <body>${html}</body>
//       </html>
//     `);
//             doc.close();

//             const handleIframeClick = (e) => {
//                 const anchor = e.target.closest('a');
//                 if (anchor && anchor.href) {
//                     e.preventDefault();
//                     window.open(anchor.href, '_blank', 'noopener,noreferrer');
//                 }
//             };

//             // Delay slightly to ensure content is rendered
//             const attachClickHandler = () => {
//                 try {
//                     const innerDoc = iframe.contentDocument || iframe.contentWindow.document;
//                     innerDoc.addEventListener('click', handleIframeClick);
//                 } catch (err) {
//                     console.error('Failed to attach click handler to iframe:', err);
//                 }
//             };

//             setTimeout(() => {
//                 attachClickHandler();
//                 // Resize height
//                 try {
//                     const height = doc.body.scrollHeight;
//                     iframe.style.height = page === "Preview" ? "350px" : page === "Previews" ? "450px" : `${height}px`;
//                 } catch (err) {
//                     console.error('Error adjusting iframe height:', err);
//                 }
//             }, 300);

//             // Cleanup on unmount
//             return () => {
//                 try {
//                     const innerDoc = iframe.contentDocument || iframe.contentWindow.document;
//                     innerDoc.removeEventListener('click', handleIframeClick);
//                 } catch (err) {
//                     // iframe might already be gone
//                 }
//             };
//         }
//     }, [html]);
//     return (
//         <iframe
//             ref={iframeRef}
//             title={`html-content-${id}`}
//             // sandbox="allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-scripts"
//             sandbox="allow-same-origin allow-scripts"
//             style={{
//                 width: '100%',
//                 border: 'none',
//                 padding: 0,
//                 margin: 0,
//                 overflow: 'hidden',
//             }}
//         />
//     );
// };

// HtmlViewer.propTypes = {
//     html: PropTypes.string.isRequired,
//     id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
//     page: PropTypes.string.isRequired,
// };

// export default HtmlViewer;
import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

const HtmlViewer = ({ html, id, page, disableInteractions = false }) => {
    const iframeRef = useRef(null);

    useEffect(() => {
        if (iframeRef.current && html) {
            const iframe = iframeRef.current;
            const doc = iframe.contentDocument || iframe.contentWindow.document;

            doc.open();
            doc.write(`
                <html>
                    <head>
                     <link
    href="https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,100..900;1,100..900&family=Story+Script&display=swap"
    rel="stylesheet">
                        <style>
                            html, body {
                                margin: 0;
                                padding: 0;
                                font-family: 'Noto Sans', sans-serif;
                                color-scheme: light;
                                font-weight: 400;
                                font-size:14px;
                            }

                            /* Modern scrollbar UI */
                            * {
                                scrollbar-width: thin;
                                scrollbar-color: rgba(0, 0, 0, 0.25) transparent;
                            }

                            *::-webkit-scrollbar {
                                width: 8px;
                                height: 8px;
                            }

                            *::-webkit-scrollbar-track {
                                background: transparent;
                            }

                            *::-webkit-scrollbar-thumb {
                                background-color: rgba(0, 0, 0, 0.25);
                                border-radius: 8px;
                                border: 2px solid transparent;
                                background-clip: padding-box;
                                transition: background-color 0.2s ease;
                            }

                            *::-webkit-scrollbar-thumb:hover {
                                background-color: rgba(0, 0, 0, 0.45);
                            }

                            *::-webkit-scrollbar-corner {
                                background: transparent;
                            }

                            ${disableInteractions ? `
                                * {
                                    pointer-events: none !important;
                                    user-select: none !important;
                                    cursor: default !important;
                                }
                            ` : ''}
                        </style>
                    </head>
                    <body>${html}</body>
                </html>
            `);
            doc.close();

            if (!disableInteractions) {
                const handleIframeClick = (e) => {
                    const anchor = e.target.closest('a');
                    if (anchor && anchor.href) {
                        e.preventDefault();
                        window.open(anchor.href, '_blank', 'noopener,noreferrer');
                    }
                };

                // Delay slightly to ensure content is rendered
                const attachClickHandler = () => {
                    try {
                        const innerDoc = iframe.contentDocument || iframe.contentWindow.document;
                        innerDoc.addEventListener('click', handleIframeClick);
                    } catch (err) {
                        console.error('Failed to attach click handler to iframe:', err);
                    }
                };

                setTimeout(() => {
                    attachClickHandler();
                    // Resize height
                    try {
                        // const height = doc.body.scrollHeight;
                        // iframe.style.height =
                        //     page === "Preview"
                        //         ? "350px"
                        //         : page === "Previews"
                        //             ? "450px"
                        //             : page === "Previewss"
                        //                 ? "250px"
                        //                 : `${height}px`;
                        const contentHeight = doc.body.scrollHeight;

                        const maxHeight =
                            page === "Preview"
                                ? 350
                                : page === "Previews"
                                    ? 450
                                    : page === "Previewss"
                                        ? 250
                                        : page === "TextBoxs" ? 250
                                            : null;

                        if (maxHeight) {
                            iframe.style.height = `${Math.min(contentHeight, maxHeight)}px`;
                            iframe.style.maxHeight = `${maxHeight}px`;
                            iframe.style.overflowY = contentHeight > maxHeight ? "auto" : "hidden";
                        } else {
                            iframe.style.height = `${contentHeight}px`;
                        }
                    } catch (err) {
                        console.error('Error adjusting iframe height:', err);
                    }
                }, 300);

                // Cleanup on unmount
                return () => {
                    try {
                        const innerDoc = iframe.contentDocument || iframe.contentWindow.document;
                        innerDoc.removeEventListener('click', handleIframeClick);
                    } catch (err) {
                        // iframe might already be gone
                    }
                };
            }
            setTimeout(() => {
                try {
                    // const height = doc.body.scrollHeight;
                    // iframe.style.height =
                    //     page === "Preview"
                    //         ? "350px"
                    //         : page === "Previews"
                    //             ? "450px"
                    //             : `${height}px`;
                    const contentHeight = doc.body.scrollHeight;

                    const maxHeight =
                        page === "Preview"
                            ? 350
                            : page === "Previews"
                                ? 450
                                : page === "Previewss"
                                    ? 250
                                    : page === "TextBoxs" ? 250
                                        : null;

                    if (maxHeight) {
                        iframe.style.height = `${Math.min(contentHeight, maxHeight)}px`;
                        iframe.style.maxHeight = `${maxHeight}px`;
                        iframe.style.overflowY = contentHeight > maxHeight ? "auto" : "hidden";
                    } else {
                        iframe.style.height = `${contentHeight}px`;
                    }
                } catch (err) {
                    console.error('Error adjusting iframe height:', err);
                }
            }, 300);

        }
    }, [html, disableInteractions]);

    return (
        <iframe
            ref={iframeRef}
            title={`html-content-${id}`}
            sandbox="allow-same-origin allow-scripts"
            style={{
                width: '100%',
                height: '0px',
                border: 'none',
                padding: 0,
                margin: 0,
                overflow: 'hidden',
            }}
        />
    );
};

HtmlViewer.propTypes = {
    html: PropTypes.string.isRequired,
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    page: PropTypes.string.isRequired,
    disableInteractions: PropTypes.bool,
};

export default HtmlViewer;



